import { Utils } from "../../common/views/Utils";
import { OrderUtils } from "../../orders/views/shared/OrderUtils";
import { ShortLineModel } from "../../products/models/ProductModel";
import { ProductUtils } from "../../products/ProductUtils";
import ProductPriceView from "../../products/views/shared/ProductPriceView";

export type CartItemProps = {
    item: ShortLineModel;
    onDelete: (item: ShortLineModel) => void;
}

export default function FavoriteItemView({ item, onDelete }: CartItemProps) {
    let url = ProductUtils.getImageUrl(item.imageUrl);

    const width2 = Utils.getColumnWidth(2, 2, 3);
    const width10 = Utils.getColumnWidth(10, 10, 9);

    return <div className="ms-Grid-row font-smaller">
        <div className={width2 + " center"}>{OrderUtils.image(url, 0, 95, 0, false)}</div>
        <div className={width10 + " left"}>
            <div className="font-bold">{item.brand}</div>
            <div className="pt-5 limit-lines one-line">{item.productName}</div>

            <div className="pt-5">
                <ProductPriceView
                    info={item.printInfo}
                    minPrice={item.minPrice}
                    maxPrice={item.maxPrice}
                />
            </div>

            <div className="pt-10">
                <div className="pointer underline" onClick={() => onDelete(item)}>Remove</div>
            </div>
        </div>
    </div>;
}